import { j as i } from "./jsx-runtime-3tyXYecC.mjs";
import { d as A } from "./index-DspsydPg.mjs";
import { F as p } from "./flex-Cc3osQLf.mjs";
import { I as N } from "./icon-v2-DGtVEk7e.mjs";
import { f as e } from "./index-LyFokDcn.mjs";
import { w as S } from "./encore-sizes-Cg5eTN64.mjs";
import { m as z } from "./tss-DN0acMKN.mjs";
import { I as _ } from "./icon-button-BxDvkq_l.mjs";
import { I as H } from "./CircleX12x12-CLsP0OlE.mjs";
import { F as b } from "./file-icon-DTzfQjIh.mjs";
import { R as Q } from "./index-CtI1AzVP.mjs";
import { L as U } from "./layout-box-DFBM-kSI.mjs";
import { P, a as R } from "./pill-DHjByxtv.mjs";
import { f as j, a as C } from "./text-B5Opw2za.mjs";
import v from "react";
const I = (n) => v.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 13 16", width: "13", height: "16" }, n),
  v.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    v.createElement("path", { fillRule: "nonzero", d: "M12.35,14.6666667 L11.7,14.6666667 C11.7,13.3653333 11.349,12.084 10.71135,11.058 L8.81075,8 L10.71135,4.942 C11.349,3.916 11.7,2.63466667 11.7,1.33333333 L12.35,1.33333333 C12.7075,1.33333333 13,1.03333333 13,0.666666667 C13,0.3 12.7075,0 12.35,0 L0.65,0 C0.2925,0 0,0.3 0,0.666666667 C0,1.03333333 0.2925,1.33333333 0.65,1.33333333 L1.3,1.33333333 C1.3,2.63466667 1.651,3.916 2.28865,4.942 L4.18925,8 L2.28865,11.058 C1.651,12.084 1.3,13.3653333 1.3,14.6666667 L0.65,14.6666667 C0.2925,14.6666667 0,14.9666667 0,15.3333333 C0,15.7 0.2925,16 0.65,16 L12.35,16 C12.7075,16 13,15.7 13,15.3333333 C13,14.9666667 12.7075,14.6666667 12.35,14.6666667 Z M4,3 L9,3 C9,4.65675 6.5,6 6.5,6 C6.5,6 4,4.65675 4,3 Z M3,14 C3,12.34325 4.5673,11 6.5,11 C8.4327,11 10,12.34325 10,14 L3,14 Z" })
  )
);
I.displayName = "Hourglass13x16";
const M = z()(({ borderRadiuses: n, constructs: l, palette: o, spacing: c, typography: r }, { theme: s }) => {
  var f, a, x, t, d, u;
  return {
    icon: {
      display: e.ifFeature("encore", "flex"),
      marginRight: e.ifFeature("encore", c(1), "6px")
    },
    info: {
      alignItems: "center",
      color: o.gray[700],
      display: "flex",
      flexDirection: "row",
      fontSize: (f = r.teenie) == null ? void 0 : f.fontSize,
      height: "auto",
      justifyContent: "space-between",
      lineHeight: 1
    },
    root: {
      backgroundColor: s === "light" ? e.ifFeature("encore", l.surface.neutral.xWeak, o.gray[100]) : e.ifFeature("encore", l.surface.neutral.weak, o.gray[200]),
      borderRadius: e.ifFeature("encore", n[400], "2px"),
      boxSizing: "border-box",
      color: o.gray[1e3],
      display: "flex",
      flexDirection: "row",
      fontSize: (a = r.teenie) == null ? void 0 : a.fontSize,
      height: e.ifFeature("encore", "128px", "112px"),
      lineHeight: (x = r.teenie) == null ? void 0 : x.lineHeight,
      padding: e.ifFeature("encore", c(2), "9px 12px 12px"),
      position: "relative",
      width: e.ifFeature("encore", S[7], "176px")
    },
    title: {
      color: e.ifFeature("encore", l.text.neutral.xStrong),
      display: "inline-block",
      fontSize: e.ifFeature("encore", r.medium.fontSize, (t = r.small) == null ? void 0 : t.fontSize),
      fontWeight: e.ifFeature("encore", r.fontWeightMedium),
      lineHeight: e.ifFeature("encore", r.medium.lineHeight, (d = r.small) == null ? void 0 : d.lineHeight),
      maxHeight: e.ifFeature("encore", "42px", "38px"),
      maxWidth: "100%",
      minHeight: "34px",
      overflow: "hidden",
      wordBreak: "break-all"
    },
    type: {
      alignItems: "center",
      color: e.ifFeature("encore", l.text.neutral.medium, o.gray[700]),
      display: "flex",
      flexDirection: "row",
      fontSize: e.ifFeature("encore", r.small.fontSize, (u = r.teenie) == null ? void 0 : u.fontSize),
      height: "auto",
      lineHeight: e.ifFeature("encore", r.small.lineHeight, 1)
    }
  };
});
function L(n) {
  return n.toLowerCase() === "esig";
}
function q(n) {
  return n.view === "attachment";
}
function O(n) {
  return n.view === "display";
}
function V(n) {
  return !n.view || n.view === "empty";
}
const Z = (n) => {
  const { children: l, fileId: o, fileName: c = "", fileType: r = "", onRemove: s, onToggle: f, theme: a = "default", toggleState: x = !1 } = n, { classes: t } = M({ theme: a }), d = l || c, u = typeof l == "string" ? l : c;
  let h = r.toUpperCase();
  const m = L(r);
  return m && (h = "Esignature"), /* @__PURE__ */ i.jsx("div", { "aria-labelledby": `filecard-${o}`, className: t.root, "data-fabric-component": "AttachmentFileCard", role: "region", children: /* @__PURE__ */ i.jsxs(p, { flexDirection: "column", flexGrow: 1, children: [
    /* @__PURE__ */ i.jsxs(p, { alignItems: "flex-start", flexDirection: "row", flexGrow: 1, justifyContent: "space-between", children: [
      /* @__PURE__ */ i.jsx("div", { className: t.title, id: `filecard-${o}`, title: u, children: d }),
      s && /* @__PURE__ */ i.jsx(p, { justifyContent: "center", marginTop: "3px", children: /* @__PURE__ */ i.jsx(
        _,
        {
          "aria-label": `${window.jQuery ? $.__("Remove File") : "Remove File"}`,
          color: "secondary",
          icon: e.ifFeature("encore", /* @__PURE__ */ i.jsx(N, { name: "circle-xmark-solid", size: 12 }), /* @__PURE__ */ i.jsx(H, {})),
          noBoundingBox: !0,
          onClick: () => s(o),
          type: "button"
        }
      ) })
    ] }),
    /* @__PURE__ */ i.jsxs("div", { className: t.info, children: [
      /* @__PURE__ */ i.jsxs("div", { className: t.type, children: [
        /* @__PURE__ */ i.jsx("div", { className: t.icon, children: e.ifFeature(
          "encore",
          /* @__PURE__ */ i.jsx(b, { type: r }),
          /* @__PURE__ */ i.jsx(b, { esig: m, type: r })
        ) }),
        h
      ] }),
      f && m && /* @__PURE__ */ i.jsx(Q, { controlled: !0, isChecked: x, onChange: () => f(o), size: "small" })
    ] })
  ] }) });
}, J = window.jQuery ? $.__("Still Needed") : "Still Needed", K = z({ name: "EmptyFileCard" })((n) => {
  const { borderRadiuses: l, constructs: o, spacing: c, palette: r, typography: s } = n;
  return {
    root: {
      backgroundColor: e.ifFeature("encore", o.surface.neutral.inverted, r.common.white),
      border: "solid 1px",
      borderColor: e.ifFeature("encore", o.border.neutral.weak, r.gray[300]),
      borderRadius: e.ifFeature("encore", l[400], "2px"),
      boxSizing: "border-box",
      display: "flex",
      flexDirection: "column",
      fontSize: j("teenie"),
      height: e.ifFeature("encore", "128px", "112px"),
      lineHeight: C("teenie"),
      padding: e.ifFeature("encore", c(2), "9px 12px 12px"),
      width: e.ifFeature("encore", S[7], "176px")
    },
    /* @startCleanup encore */
    jade_icon: {
      fill: e.ifFeature("encore", void 0, r.gray[600])
    },
    /* @endCleanup encore */
    info: {
      alignItems: "center",
      color: e.ifFeature("encore", o.text.neutral.weak, r.gray[500]),
      display: "flex",
      fontSize: e.ifFeature("encore", s.small.fontSize, j("teenie")),
      height: "auto",
      lineHeight: e.ifFeature("encore", s.small.lineHeight, C("teenie"))
    },
    title: {
      color: e.ifFeature("encore", o.text.neutral.weak, r.gray[500]),
      display: "inline-block",
      fontSize: e.ifFeature("encore", s.medium.fontSize, j("small")),
      fontWeight: e.ifFeature("encore", s.fontWeightMedium),
      lineHeight: e.ifFeature("encore", s.medium.lineHeight, C("small")),
      maxHeight: e.ifFeature("encore", "42px", "38px"),
      minHeight: "34px",
      overflow: "hidden",
      width: "100%",
      wordBreak: "break-all"
    }
  };
}), D = (n) => {
  const { children: l, fileName: o = "" } = n, c = l || o, { classes: r } = K();
  return (
    // eslint-disable-next-line jsx-a11y/role-supports-aria-props
    /* @__PURE__ */ i.jsxs(
      "div",
      {
        "aria-disabled": !0,
        "aria-label": `${o}`,
        className: r.root,
        "data-fabric-component": "EmptyFileCard",
        role: "region",
        children: [
          /* @__PURE__ */ i.jsx(p, { flexGrow: 1, maxWidth: "100%", children: /* @__PURE__ */ i.jsx("div", { className: r.title, children: c }) }),
          /* @__PURE__ */ i.jsxs("div", { className: r.info, children: [
            /* @__PURE__ */ i.jsx(p, { marginRight: e.ifFeature("encore", 1, "6px"), children: e.ifFeature(
              "encore",
              /* @__PURE__ */ i.jsx(
                N,
                {
                  ariaLabel: window.jQuery ? $.__("Hourglass icon") : "Hourglass icon",
                  color: "neutral-weak",
                  name: "hourglass-regular",
                  size: 20
                }
              ),
              /* @__PURE__ */ i.jsx("span", { className: r.jade_icon, children: /* @__PURE__ */ i.jsx(I, {}) })
            ) }),
            J
          ] })
        ]
      }
    )
  );
}, X = window.jQuery ? $.__("Canceled") : "Canceled", Y = window.jQuery ? $.__("Signers Pending") : "Signers Pending", ee = window.jQuery ? $.__("Sign Now") : "Sign Now", ie = window.jQuery ? $.__("Signed") : "Signed", re = window.jQuery ? $.__("No Signature Needed") : "No Signature Needed", te = window.jQuery ? $.__("Chose Not to Sign") : "Chose Not to Sign", ne = window.jQuery ? $.__("Virus Detected") : "Virus Detected", oe = z()((n, l, o) => {
  var F;
  const { borderRadiuses: c, constructs: r, mixins: s, spacing: f, palette: a, transitions: x, typography: t } = n, { isSafe: d, isDisabled: u, signatureState: h, onClick: m } = l, g = d && m && {
    [`& .${o.title}`]: {
      color: e.ifFeature("encore", r.text.link.hover),
      textDecoration: "underline",
      transition: e.ifFeature("encore", x.create(["color", "fill"]))
    }
  };
  return {
    root: {
      position: "relative",
      height: e.ifFeature("encore", "128px", "112px"),
      width: e.ifFeature("encore", S[7], "176px")
    },
    container: {
      appearance: "none",
      // For button element
      backgroundColor: e.ifFeature("encore", r.surface.neutral.xWeak, a.gray[100]),
      border: `1px solid ${e.ifFeature("encore", r.border.neutral.weak, a.gray[400])}`,
      borderRadius: e.ifFeature("encore", c[400], "2px"),
      boxShadow: e.ifFeature("encore", s.boxShadow("300", r.surface.neutral.xxStrong), "none"),
      boxSizing: "border-box",
      color: a.gray[1e3],
      display: "flex",
      flexDirection: "row",
      fontSize: t.teenie.fontSize,
      height: e.ifFeature("encore", "128px", "112px"),
      lineHeight: t.teenie.lineHeight,
      padding: e.ifFeature("encore", f(2), "9px 12px 12px"),
      position: "relative",
      textAlign: "left",
      // For button element
      width: e.ifFeature("encore", S[7], "176px"),
      "&:hover": {
        ...!u && d ? {
          // @startCleanup encore
          backgroundColor: e.ifFeature("encore", void 0, a.gray[200]),
          // @endCleanup encore
          border: "solid 1px",
          borderColor: e.ifFeature("encore", r.border.primary.strong, a.gray[400]),
          boxShadow: e.ifFeature("encore", s.boxShadow("300", r.surface.neutral.xxStrong), "none"),
          transition: x.create(["border", "fill"]),
          ...g
        } : {}
      },
      cursor: !u && d && m ? "pointer" : void 0,
      // Additional styles for when root is a button
      "&:focus": {
        ...s.focusRing(a.primary),
        borderColor: r.border.primary.strong,
        boxShadow: `0 0 0 4px ${s.alpha(r.border.primary.strong, 0.1)}`
      },
      "&:disabled": {
        cursor: "not-allowed"
      }
    },
    info: {
      color: a.gray[700],
      display: "inline-block",
      fontSize: t.teenie.fontSize,
      height: "auto",
      lineHeight: 1,
      opacity: u || !d ? 0.5 : void 0
    },
    esig: {
      borderRadius: e.ifFeature("encore", c[100], "2px"),
      fontSize: e.ifFeature("encore", t.small.fontSize, "12px"),
      fontWeight: e.ifFeature("encore", t.fontWeightRegular, t.fontWeightSemibold),
      lineHeight: e.ifFeature("encore", t.small.lineHeight, "15px"),
      margin: 0,
      // @startCleanup encore
      padding: e.ifFeature("encore", void 0, "2px 0"),
      // @endCleanup encore
      textOverflow: "ellipsis"
    },
    removeButton: {
      display: "flex",
      position: "absolute",
      right: "17px",
      top: "20px"
    },
    title: {
      display: "inline-block",
      fontSize: e.ifFeature("encore", t.medium.fontSize, t.small.fontSize),
      fontWeight: e.ifFeature("encore", t.fontWeightMedium),
      lineHeight: e.ifFeature("encore", t.medium.lineHeight, t.teenie.lineHeight),
      maxHeight: e.ifFeature("encore", "42px", "38px"),
      maxWidth: "100%",
      minHeight: "34px",
      overflow: "hidden",
      wordBreak: "break-all",
      ...m && d ? {
        color: e.ifFeature("encore", r.text.link.idle, a.info.main),
        fontSize: e.ifFeature("encore", t.medium.fontSize, t.small.fontSize),
        fontWeight: e.ifFeature("encore", t.fontWeightMedium, t.fontWeightBold)
      } : {}
    },
    type: {
      alignItems: "center",
      color: e.ifFeature("encore", r.text.neutral.medium, a.gray[700]),
      display: "inline-flex",
      flexDirection: "row",
      fontSize: e.ifFeature("encore", t.small.fontSize, t.teenie.fontSize),
      height: "auto",
      lineHeight: e.ifFeature("encore", t.small.lineHeight, 1)
    },
    // @startCleanup encore
    jadePill: {
      // This class only shows up when Jade is set to true
      backgroundColor: h === "required" ? (F = a.action) == null ? void 0 : F.highlight : a.success.main,
      borderRadius: "2px",
      color: h === "required" ? a.gray[1e3] : "white",
      fontWeight: t.fontWeightBold,
      padding: "3px 6px",
      textOverflow: "ellipsis"
    }
    // @endCleanup encore
  };
}), ae = (n) => {
  const {
    children: l,
    fileId: o,
    fileName: c = "",
    fileType: r,
    isDisabled: s = !1,
    isSafe: f = !0,
    onClick: a,
    onRemove: x,
    signatureState: t = "pending"
  } = n, d = l || c, u = typeof d == "string" ? d : "";
  let h = r.toUpperCase();
  const m = L(r), { classes: g } = oe({ isDisabled: s, isSafe: f, onClick: a, signatureState: t });
  m && (h = "Esignature");
  function F() {
    a && typeof a == "function" && f && a(o);
  }
  function E() {
    if (!x || s)
      return null;
    const w = (G) => {
      s || (x(o), G.stopPropagation());
    }, B = e.ifFeature("encore", /* @__PURE__ */ i.jsx(N, { name: "circle-xmark-solid", size: 12 }), /* @__PURE__ */ i.jsx(H, {}));
    return /* @__PURE__ */ i.jsx("div", { className: g.removeButton, children: /* @__PURE__ */ i.jsx(
      _,
      {
        "aria-label": `${window.jQuery ? $.__("Remove File") : "Remove File"} ${u}`,
        color: "secondary",
        icon: B,
        noBoundingBox: !0,
        onClick: w,
        type: "button"
      }
    ) });
  }
  function T() {
    return /* @__PURE__ */ i.jsx("div", { className: g.title, title: u, children: d });
  }
  function y() {
    return t === "canceled" ? X : t === "required" ? ee : t === "signed" ? ie : t === "noSignatureNeeded" ? re : t === "declined" ? te : Y;
  }
  function W() {
    let w = h;
    return f || (w = ne), m ? /* @__PURE__ */ i.jsx("div", { className: g.esig, children: e.ifFeature(
      "encore",
      t === "required" || t === "signed" ? /* @__PURE__ */ i.jsx(P, { type: t === "required" ? R.Warning : R.Success, children: y() }) : y(),
      t === "required" || t === "signed" ? /* @__PURE__ */ i.jsx("div", { className: g.jadePill, children: y() }) : y()
    ) }) : w;
  }
  const k = /* @__PURE__ */ i.jsxs(p, { flexDirection: "column", flexGrow: 1, children: [
    /* @__PURE__ */ i.jsx(p, { alignItems: "start", flexGrow: 1, justifyContent: "space-between", maxWidth: "100%", children: T() }),
    /* @__PURE__ */ i.jsx("div", { className: g.info, children: /* @__PURE__ */ i.jsxs("div", { className: g.type, title: u, children: [
      e.ifFeature(
        "encore",
        /* @__PURE__ */ i.jsx(p, { marginRight: 1, children: /* @__PURE__ */ i.jsx(b, { esig: m, type: r }) }),
        /* @__PURE__ */ i.jsx(U, { marginRight: "6px", children: /* @__PURE__ */ i.jsx(b, { esig: m, type: r }) })
      ),
      W()
    ] }) })
  ] });
  return a ? /* @__PURE__ */ i.jsxs("div", { className: g.root, "data-fabric-component": "DisplayFileCard", children: [
    /* @__PURE__ */ i.jsx("button", { className: g.container, disabled: s || !f, onClick: F, type: "button", children: k }),
    E()
  ] }) : /* @__PURE__ */ i.jsxs("div", { className: g.root, "data-fabric-component": "DisplayFileCard", children: [
    /* @__PURE__ */ i.jsx("div", { className: g.container, children: k }),
    E()
  ] });
}, le = A.createLogger("@fabric/file-card | <FileCard />"), je = (n) => {
  let l;
  return q(n) ? l = Z : O(n) ? l = ae : (V(n) || le.warn('"view" was invalid. Defaulting to "empty"'), l = D), /* @__PURE__ */ i.jsx("div", { className: "fab-FileCard", "data-fabric-component": "FileCard", children: /* @__PURE__ */ i.jsx(l, { ...n }) });
};
export {
  Z as A,
  ae as D,
  D as E,
  je as F
};
//# sourceMappingURL=file-card-BJQXxJ4_.mjs.map
